// src/components/fields/SelectCountrySADC.jsx
import React from "react";
import { AFRIMED_MARKETS } from "@/config/markets.js";
import MarketCountryPicker from "@/components/markets/MarketCountryPicker.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

function findMarketIsoByName(name) {
  return (
    AFRIMED_MARKETS.find((market) => market.name === name)?.iso || ""
  );
}

export default function SelectCountrySADC({
  label,
  value = "",
  placeholder,
  onChange,
  tone = "auth",
  useTextFieldTrigger = false,
}) {
  const { t } = useLanguage();
  return (
    <MarketCountryPicker
      label={label ?? t("fields.country.requiredLabel", "Country*")}
      value={findMarketIsoByName(value)}
      placeholder={placeholder ?? t("fields.country.placeholder", "Select country")}
      searchPlaceholder={t("fields.country.searchPlaceholder", "Search countries")}
      tone={tone}
      useTextFieldTrigger={useTextFieldTrigger}
      onChange={(market) => onChange?.(market?.name || "")}
    />
  );
}
